import { Box, Typography } from "@mui/material";
import Loader from "components/Loader";
import React from "react";
import { useGetSpecificInventoryQuery } from "state/api";

const FieldName = [
  {
    name: "Make",
    value: "name",
  },
  {
    name: "Model",
    value: "model",
  },
  // {
  //   name: "Model",
  //   value: "model",
  // },
  // {
  //   name: "Owner Serial",
  //   value: "ownerSerial",
  // },
  {
    name: "Registration Type",
    value: "registrationType",
  },
  // {
  //   name: "Price",
  //   value: "price",
  // },
  // {
  //   name: "Year of Manufacture",
  //   value: "yearOfManufacture",
  // },
  // {
  //   name: "Variant",
  //   value: "variant",
  // },
  // {
  //   name: "Color",
  //   value: "color",
  // },
  {
    name: "Fuel Type",
    value: "fuelType",
  },
  {
    name: "Transmission",
    value: "transmission",
  },
  // {
  //   name: "Kilometers Driven",
  //   value: "kmsDriven",
  // },
  {
    name: "Status",
    value: "status",
  },
  {
    name: "Chassis Number",
    value: "chassisNumber",
  },
  {
    name: "Inventory Type",
    value: "inventoryType",
  },
  // {
  //   name: "Vehicle Number",
  //   value: "vehicleNumber",
  // },
  // {
  //   name: "Engine Number",
  //   value: "engineNumber",
  // },
];

const CarDetails = ({ carId }) => {
  const { data, isLoading } = useGetSpecificInventoryQuery(carId);
  if (isLoading) return <Loader />;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "2rem",
          borderRadius: "0.5rem",
          border: "1px solid",
          borderColor: "grey.200",
          mt: "1rem",
          width: "80%",
        }}
        className="bg-black/10"
      >
        <Typography variant="h4" component="span" className="font-extrabold">
          Car Details
        </Typography>

        {FieldName.map((item) => (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              borderRadius: "0.5rem",
              width: "100%",
              gap: "1rem",
              padding: "0.5rem",
            }}
            key={item.value}
          >
            <Typography variant="h6" component="span">
              {item.name}
            </Typography>
            <Typography variant="h6" component="span">
              {item?.type !== "date" ? data[item.value] : ""}
              {item?.type === "date"
                ? new Date(data[item.value]).toDateString({
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : ""}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default CarDetails;
